/**
 * CreatePackageButton
 * Clean dropdown for creating new correspondence packages.
 */

import { PlusIcon } from '@heroicons/react/20/solid';
import { ArrowPathIcon } from '@heroicons/react/24/outline';

import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { cn } from '@/lib/utils';

import { CREATABLE_PACKAGE_TYPES, PACKAGE_TYPE_CONFIG } from '../constants';
import type { CorrespondencePackageType } from '../types';

interface CreatePackageButtonProps {
  onSelect: (type: CorrespondencePackageType) => void;
  isLoading?: boolean;
}

export const CreatePackageButton: React.FC<CreatePackageButtonProps> = ({
  onSelect,
  isLoading = false,
}) => (
  <DropdownMenu>
    <DropdownMenuTrigger asChild>
      <Button
        disabled={isLoading}
        className="bg-stone-900 text-white hover:bg-stone-800 h-9 px-3 gap-1.5 shadow-sm"
      >
        {isLoading ? (
          <ArrowPathIcon className="h-4 w-4 animate-spin" />
        ) : (
          <PlusIcon className="h-4 w-4" />
        )}
        New
      </Button>
    </DropdownMenuTrigger>
    <DropdownMenuContent align="end" className="w-56 p-1">
      {CREATABLE_PACKAGE_TYPES.map((type) => {
        const config = PACKAGE_TYPE_CONFIG[type];
        return (
          <DropdownMenuItem
            key={type}
            onClick={() => onSelect(type)}
            className="cursor-pointer rounded py-2 px-3"
          >
            <span
              className={cn('h-2 w-2 rounded-full mr-2.5', config.dotColor)}
            />
            <span className="text-sm">{config.label}</span>
          </DropdownMenuItem>
        );
      })}
    </DropdownMenuContent>
  </DropdownMenu>
);
